module.exports = __webpack_public_path__ + "media/images/logos/twitch-1c0865cbf916e781f30811116e8842b9.svg";